import Vue from 'vue'
import timePopup from './timeDialog.vue'

const PopupBox = Vue.extend(timePopup);

timePopup.install = function (data) {
  let instance = new PopupBox({
    data
  }).$mount();

  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.show = true
    // show 和弹窗组件里的show对应，用于控制显隐
  })
};

export default timePopup



// WEBPACK FOOTER //
// ./src/components/popup/timeDialog.js